export default "__VITE_ASSET__08d09cef__"